import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import CommonText from './components/CommonText';

const Title = () => <CommonText fieldName={ISSUE_ATTRIBUTE_NAMES.TITLE} label="new.title" />;

export default Title;
